import {
  collection,
  doc,
  getDocs,
  limit,
  query,
  writeBatch,
  type CollectionReference,
  type DocumentReference,
} from 'firebase/firestore';
import { db } from './firebase';
import { getLeadsCollectionName } from './leadsCollectionName';

export function leadCommentsCollectionRef(leadId: string): CollectionReference {
  return collection(db, getLeadsCollectionName(), leadId, 'comments');
}

export function leadCommentDocRef(leadId: string, commentId: string): DocumentReference {
  return doc(db, getLeadsCollectionName(), leadId, 'comments', commentId);
}

export function leadCommentsCollectionRefForCollection(
  leadsCollection: string,
  leadId: string,
): CollectionReference {
  return collection(db, leadsCollection, leadId, 'comments');
}

/**
 * Team notes used to always write under `leads/{id}/comments` even when the lead
 * doc lived in `testLeads`. If the canonical path is empty, copy any orphan notes
 * from the other collection tree (same lead id).
 */
export async function migrateOrphanLeadCommentsIfNeeded(leadId: string): Promise<number> {
  if (!leadId) return 0;
  const primary = getLeadsCollectionName();
  const alternate = primary === 'testLeads' ? 'leads' : 'testLeads';

  const primaryRef = leadCommentsCollectionRef(leadId);
  const primarySnap = await getDocs(query(primaryRef, limit(1)));
  if (!primarySnap.empty) return 0;

  const orphanSnap = await getDocs(leadCommentsCollectionRefForCollection(alternate, leadId));
  if (orphanSnap.empty) return 0;

  const batch = writeBatch(db);
  orphanSnap.docs.forEach(d => {
    batch.set(doc(primaryRef, d.id), d.data());
  });
  await batch.commit();
  return orphanSnap.size;
}
